import React, { useState } from "react";
import TimeSlot from "./TimeSlot";

const TimeSlots = ({ timeSlots, setTimeSlots, minHoursOptionsRows, maxHoursOptionsRows, interval = 30 }) => {
  const [invalidTimeSlots, setInvalidTimeSlots] = useState([]);

  const onTimeSlotChange = (index, field, value) => {
    const newTimeSlots = [...timeSlots];
    newTimeSlots[index][field] = value;
    setTimeSlots(newTimeSlots);
    checkTimeSlots(newTimeSlots);
  };

  const onAddNewTimeSlot = () => {
    const newTimeSlots = [...timeSlots, { from: "", to: "" }];
    setTimeSlots(newTimeSlots);
    checkTimeSlots(newTimeSlots);
  };

  const onDeleteTimeSlot = (index) => {
    const newTimeSlots = timeSlots.filter((timeSlot, i) => i !== index);
    setTimeSlots(newTimeSlots);
    checkTimeSlots(newTimeSlots);
  };

  const timeToMinutes = (time) => {
    if (!time) return 0;
    const [hours, minutes] = time.split(":").map(Number);
    return hours * 60 + minutes;
  };

  // Function to check for duplicate or overlapping time slots and return their indices
  const checkTimeSlots = (timeSlots) => {
    // Convert time slots to minutes and sort by start time, keeping track of original indices
    const slots = timeSlots
      .map((slot, index) => ({
        from: timeToMinutes(slot.from),
        to: timeToMinutes(slot.to),
        index,
      }))
      .sort((a, b) => a.from - b.from);

    const invalidIndices = [];

    // Check for overlapping or duplicate time slots
    for (let i = 1; i < slots.length; i++) {
      if (slots[i].from < slots[i - 1].to) {
        invalidIndices.push(slots[i - 1].index, slots[i].index);
      }
    }

    // Remove duplicates from invalidIndices
    setInvalidTimeSlots([...new Set(invalidIndices)]);
  };

  return (
    <div className="w-full md:w-auto flex flex-col gap-4">
      {timeSlots.map((timeSlot, index) => (
        <div className="w-full flex" key={`time-slot-${index}`}>
          <TimeSlot
            timeSlot={timeSlot}
            setFromSlot={(value) => onTimeSlotChange(index, "from", value)}
            setToSlot={(value) => onTimeSlotChange(index, "to", value)}
            isValid={invalidTimeSlots.indexOf(index) === -1}
            canDelete={timeSlots.length > minHoursOptionsRows}
            canAdd={index === timeSlots.length - 1 && timeSlots.length < maxHoursOptionsRows}
            onAddNewTimeSlot={onAddNewTimeSlot}
            onDeleteTimeSlot={() => onDeleteTimeSlot(index)}
            interval={interval}
          />
        </div>
      ))}
    </div>
  );
};

export default TimeSlots;
